import {
    apiRequest,
    userInfoList,
    userInfoActive,
    userInfoInactive,
} from "../../../../../../services/adapters/master/refMesinAbsenUserInfoService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", userInfoList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", userInfoInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", userInfoActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository